module.exports = __webpack_public_path__ + "static/media/icon-meep-app.3a5223dd.svg";